import React, {useState} from "react";
import apiClient from "../../clients/apiClient.js";
import { Box, Button, Flex, Grid, HStack, Input, InputGroup, InputLeftElement, Menu, MenuButton, MenuItem, MenuList, Spacer, Spinner, Text, VStack } from "@chakra-ui/react";
import { AddOutlined, MoreHoriz } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import ControlArrows from "../../utils/ControlArrows";
import SearchIcon from "@mui/icons-material/Search";
import CreateGroupModal from "./CreateGroupModal";
import EditGroupModal from "./EditGroupModal";
import DeleteGroupModal from "./DeleteGroupModal";

const GroupsTab = ({groups, setGroups, loading, groupsData, teamMembers}) => {
    const [searchQuery, setSearchQuery] = React.useState(''); // State for search query
    const [sortColumn, setSortColumn] = useState('name');
    const [sortDirection, setSortDirection] = useState('asc');
    const [filteredGroups, setFilteredGroups] = useState(groups);
  
    const [showPopup, setShowPopup] = useState(false);
    const [editGroupModalOpen, setEditGroupModalOpen] = useState(false);
    const [groupToEdit, setGroupToEdit] = useState(null);
    const [deleteGroupModalOpen, setDeleteGroupModalOpen] = useState(false);
    const [groupToDelete, setGroupToDelete] = useState(null);
  
  
    React.useEffect(() => {
      setFilteredGroups(groups?.filter(
        (group) =>
          group.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          group.name?.toLowerCase().includes(searchQuery.toLowerCase())
      ));
    }, [searchQuery, groups])
  
    React.useEffect(() => {
      if (sortDirection === "asc") {
          const sortedMembers = [...(filteredGroups || [])].sort((a, b) => {
              if (sortColumn === "name") {
                  return (a.name).localeCompare(b.name);
              } else if (sortColumn === "members") {
                  return a.members.length - b.members.length;
              }
              return 0;
          })
          setFilteredGroups(sortedMembers);
      } else {
          const sortedMembers = [...(filteredGroups || [])].sort((a, b) => {
              if (sortColumn === "name") {
                  return (b.name).localeCompare(a.name);
              } else if (sortColumn === "members") {
                  console.log("members", a.members.length, b.members.length)
                  return b.members.length - a.members.length;
              }
              return 0;
          })
          setFilteredGroups(sortedMembers);
      }
  }, [sortColumn, sortDirection]);
  
    const handleClose = () => {
      setShowPopup(false);
    };

    const addGroup = (group) => {
      setGroups((prevGroups) => [...prevGroups, group]);
    }

    const editGroup = (updatedGroup) => {
      setGroups((prevGroups) =>
        prevGroups.map((group) => (group.id === updatedGroup.id ? updatedGroup : group))
      );
    }

    const deleteGroup = (deletedGroup) => {
      setGroups((prevGroups) => prevGroups.filter((group) => group.id !== deletedGroup.id));
    }

    const openEditGroupModal = (group) => {
      setGroupToEdit(group);
      setEditGroupModalOpen(true);
    }

    const openDeleteGroupModal = (group) => {
      setGroupToDelete(group);
      setDeleteGroupModalOpen(true);
    }
  
    if (loading || !groups)
      return (
        <Flex width={'100%'} height="72vh" justifyContent={'center'} alignItems={"center"} py={20}>
          <Spinner
            thickness="4px"
            speed="0.65s"
            emptyColor="gray.200"
            color="blue.500"
            size="lg"
          />
        </Flex>
      );
  
    const canCreateGroup = () => {
      if (groupsData?.can_create_group) {
        return true;
      }
  
      return false;
    }
  
    // const isRemoveAccessDisabled = () => {
    //   if (teamMembersData?.can_revoke_team_members == false) {
    //     return true;
    //   }
  
    //   return false;
    // }
  
    return (
      <Box marginBottom={"24px"}>
        <Flex align="center" mb={4} gap={"24px"}>
          <InputGroup maxW="240px" borderRadius={"8px"}>
            <InputLeftElement pointerEvents="none">
              {/* <IconButton icon={SearchIcon} style={{ color: 'grey' }} /> */}
              <IconButton style={{ color: 'grey' }} ><SearchIcon/></IconButton>
            </InputLeftElement>
            <Input
              placeholder="Search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)} // Update search query
            />
          </InputGroup>
  
          <Spacer />
  
          <Text fontSize="16px" color="#fffff">
            {groups?.length} Groups
          </Text>
          <Button
            color={"white"}
            bgColor={"#2584FD"}
            colorScheme="blue"
            onClick={() => setShowPopup(true)}
            disabled={!canCreateGroup()}
            gap={"6px"}
            width={"158px"}
          >
            <IconButton
              sx={{ padding: 0, fontSize: "24px", color: "white", height: "24px", width: "24px" }}
            >
              <AddOutlined sx={{ padding: 0, fontSize: "22px" }}/>
            </IconButton>
            <Text fontSize={"16px"} lineHeight={"24px"} fontWeight={"600"}>
              Create a group
            </Text>
          </Button>
        </Flex>
        {/* Search and Actions */}
        <CreateGroupModal isModalOpen={showPopup} onClose={handleClose} teamMembers={teamMembers} addGroup={addGroup}/>
        <EditGroupModal isModalOpen={editGroupModalOpen} onClose={() => setEditGroupModalOpen(false)} groupToEdit={groupToEdit} teamMembers={teamMembers} editGroup={editGroup}/>
        <DeleteGroupModal isModalOpen={deleteGroupModalOpen} onClose={() => setDeleteGroupModalOpen(false)} groupToDelete={groupToDelete} deleteGroup={deleteGroup}/>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
                <tr>
                    <th style={{ borderBottom: "1px solid #e5e5e5", padding: "8px", textAlign: "left" }}>
                        Group Name
                        <ControlArrows columnName="name" sortColumn={sortColumn} setSortColumn={setSortColumn} sortDirection={sortDirection} setSortDirection={setSortDirection}/>
                    </th>
                    <th style={{ borderBottom: "1px solid #e5e5e5", padding: "8px", textAlign: "left" }}>
                        Description
                    </th>
                    <th style={{ borderBottom: "1px solid #e5e5e5", padding: "8px", textAlign: "left" }}>
                        Members
                        <ControlArrows columnName="members" sortColumn={sortColumn} setSortColumn={setSortColumn} sortDirection={sortDirection} setSortDirection={setSortDirection}/>
                    </th>
                    <th style={{ borderBottom: "1px solid #e5e5e5", padding: "8px", textAlign: "center" }}>
                        Actions
                    </th>
                </tr>
            </thead>
            <tbody style={{ height: "10px", overflowY: "hidden" }}>
                {filteredGroups.map((group) => {
                    const { id, name, members, description } = group;
                        return (
                        <tr key={id} style={{ width: "100%", textAlign: "left" }}>
                          <td style={{ borderBottom: "1px solid #e5e5e5", padding: "8px", textAlign: "left" }}>
                          <Text fontWeight="500">
                          {name}
                          </Text>
                          </td>
                          <td style={{ borderBottom: "1px solid #e5e5e5", padding: "8px", textAlign: "left", maxWidth: "300px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          <Text fontWeight="500">
                          {description}
                          </Text>
                          </td>
                          <td style={{ borderBottom: "1px solid #e5e5e5", padding: "8px", textAlign: "left" }}>
                          {members
                          ?.sort((a, b) => a.first_name?.localeCompare(b.first_name))
                          .slice(0, 1)
                          .map((member) => (member.first_name+ ' ' +member.last_name))
                          .join(", ")}
                          {members?.length > 1 && (
                          <span
                            style={{
                              display: "inline-flex",
                              justifyContent: "center",
                              alignItems: "center",
                              marginLeft: "8px",
                              width: "24px",
                              height: "24px",
                              borderRadius: "50%",
                              backgroundColor: "#f0f4ff",
                              color: "#28a745",
                              fontSize: "12px",
                              fontWeight: "bold",
                            }}
                          >
                            <Text fontSize={"14px"} lineHeight={"16px"} fontWeight={"400"}>
                              +{members.length - 1}
                            </Text>
                          </span>
                          )}
                          </td>
                          <td style={{ borderBottom: "1px solid #e5e5e5", padding: "8px", textAlign: "left" }}>
                          <Grid placeItems="center" h="100%">
                          <Menu placement="bottom" justify={"flex-end"} offset={[-0, -20]}>
                            <MenuButton
                            as={IconButton}
                            sx={{ paddingX: 0, paddingY: 0.5, "&:hover": { backgroundColor: "transparent" } }}
                            >
                              <MoreHoriz sx={{ padding: 0, fontSize: 20, color: "#A1B3D3", bgcolor: "transparent" }} />
                            </MenuButton>
                            <MenuList
                              borderRadius={"8px"}
                              paddingX={0}
                              paddingY={0}
                              width={"120px"}
                              marginTop={"8px"}
                              boxShadow={"0px 4px 8px rgba(0, 0, 0, 0.1)"}
                              backgroundColor={"#FFFFFF"}
                              border={"1px solid #E5E5E5"}
                              borderColor={"#E5E5E5"}
                              minW={"unset"}
                            >
                              <MenuItem
                                paddingX={4}
                                paddingY={2}
                                fontSize={"14px"}
                                fontWeight={"400"}
                                color={"#1D1D1D"}
                                fontFamily={"'Inter', sans-serif"}
                                _hover={{ backgroundColor: "#E4F0FF" }}
                                onClick={() => {openEditGroupModal(group)}}
                              >
                                Edit
                              </MenuItem>
                              <MenuItem
                                paddingX={4}
                                paddingY={2}
                                fontSize={"14px"}
                                fontWeight={"400"}
                                color={"#1D1D1D"}
                                fontFamily={"'Inter', sans-serif"}
                                _hover={{ backgroundColor: "#E4F0FF" }}
                                onClick={() => {openDeleteGroupModal(group)}}
                              >
                                Delete
                              </MenuItem>
                            </MenuList>
                          </Menu>
                          </Grid>
                          </td>
                        </tr>
                        )})}
            </tbody>
        </table>
      </Box>
    )
  }

export default GroupsTab;